import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { RoofLine } from 'store/slices/RoofToolLinesSlice/types';
import { EDGE_TYPES, roofLines } from './constant';

// Edge colours that sink into the dark UI (dropdown swatches, legend) are lifted a step in dark mode.
// The map lines use the same palette so swatch and line always match.
const DARK_MODE_OVERRIDES: Partial<Record<string, string>> = {
	[EDGE_TYPES.RIDGES]: '#9D4DFF',
	[EDGE_TYPES.RAKES]: '#C94A5E',
	[EDGE_TYPES.NONE]: '#9A9CBF',
};

const darkRoofLines: Record<string, RoofLine> = Object.fromEntries(
	Object.entries(roofLines).map(([key, line]) => [key, { ...line, color: DARK_MODE_OVERRIDES[key] ?? line.color }])
);

export default function useRoofLines(): Record<string, RoofLine> {
	const displayMode = useSelector((state: RootState) => state.QueryParams.data.displayMode);
	return useMemo(() => (displayMode === 'dark' ? darkRoofLines : roofLines), [displayMode]);
}
